import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RecentCallBox, DialBoxCall, BodyClass, InputBox } from './style';
import { globalStateSelector } from '../../../store/selector';
import AgentList from '../common/AgentList';
import { callAction } from '../../../store/action';
import { connect } from 'react-redux';
export class RecentCall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      list: []
    };
    this.dialNumber = this.dialNumber.bind(this);
  }
  componentDidMount() {}
  sendMessage(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }
  getTypeUrl(type) {
    if (type == 'Inbound' || type == 'incomming' ) {
      return '/images/inbound-call.png';
    } else if( type == 'Missed' ){
      return '/images/missed-call.png';
    }
    return '/images/outgoing-call.png';
  }
  dialNumber(config) {
    if (config.number) {
      this.sendMessage('callInitiate', {
        phoneNumber: config.number,
        ...config
      });
    } else {
      console.error(`[Click2Call] Number Not Found`);
    }
  }
  renderCallList(list) {
    if (list.length == 0) {
      return <div style={{ height: '204px' }}>No Data</div>;
    }
    return (
      <React.Fragment>
        {list.map(data => {
          data.number = data.number;
          return (
            <AgentList
              image={this.getTypeUrl(data.type)}
              name={data.name}
              message={data.message}
              extraMessage={data.extraMessage || ""}
              time={data.time}
              dialNumber={this.dialNumber}
              callInfo={data}
            />
          );
        })}
      </React.Fragment>
    );
  }
  render() {
    const { callList } = this.props;

    return (
      <span>
        <BodyClass>
          <InputBox>
            <input
              type="text"
              className="inputBox"
              placeholder="Search People"
            />
            <i className="fa fa-search"></i>
          </InputBox>
        </BodyClass>
        <RecentCallBox>
          <DialBoxCall>{this.renderCallList(callList)}</DialBoxCall>
        </RecentCallBox>
      </span>
    );
  }
}
RecentCall.contextTypes = {
  __: PropTypes.func
};

RecentCall.propTypes = {
  callProcess: PropTypes.func
};

const stateToProps = state => ({
  callList: globalStateSelector.getRecentCallList(state)
});

const dispatchToProps = dispatch => ({
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  }
});
export default connect(stateToProps, dispatchToProps)(RecentCall);



// WEBPACK FOOTER //
// src/dialpad/components/layout/RecentCall.js